import { memo } from "react";

const WaiterIcon = memo(({ color }) => {
  return (
    <svg height="2.8vh" viewBox="0 0 30 30" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 2.5C13.6739 2.5 12.4021 3.02678 11.4645 3.96447C10.5268 4.90215 10 6.17392 10 7.5C10 8.82608 10.5268 10.0979 11.4645 11.0355C12.4021 11.9732 13.6739 12.5 15 12.5C16.3261 12.5 17.5979 11.9732 18.5355 11.0355C19.4732 10.0979 20 8.82608 20 7.5C20 6.17392 19.4732 4.90215 18.5355 3.96447C17.5979 3.02678 16.3261 2.5 15 2.5Z"
        fill={color}
      />
      <path
        d="M7.5 15C6.83696 15 6.20107 15.2634 5.73223 15.7322C5.26339 16.2011 5 16.837 5 17.5V18.125C5 20.2875 6.2625 22.075 8.1375 23.225C10.0125 24.375 12.4375 25 15 25C17.5625 25 19.9875 24.375 21.8625 23.225C23.7375 22.075 25 20.2875 25 18.125V17.5C25 16.837 24.7366 16.2011 24.2678 15.7322C23.7989 15.2634 23.163 15 22.5 15H7.5Z"
        fill={color}
      />
      <path
        d="M3.75 7.5H8.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M21.25 7.5H26.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
});

export default WaiterIcon;
